import BaseMyBetsStore from "./BaseMyBetsStore";

export default class MyBetsStore extends BaseMyBetsStore {}
